export default "__VITE_ASSET__Cj54FdzP__"